import { Brand, createBranded } from '@deltasierra/type-utilities';

export type PlannerId = Brand<number, 'PlannerId'>;
export const PlannerId = createBranded<PlannerId>();
